


































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';

@Component
export default class DlgMemberNew extends Vue {
  public $refs!: {
    form: any,
  };

  @Prop({type: Object, default: null}) private animal!: any;
  @Action('moderator/animals/update') private updateAnimal!: any;
  @Action('moderator/animals/read') private readAnimals!: any;
  @Action('moderator/animals/uploadImage') private uploadImage!: any;
  @Getter('common/rules/all') private rules!: any;

  private localAnimal: any = null;
  private dialog: boolean = false;
  private loading: boolean = false;
  private valid: boolean = true;

  @Watch('dialog')
  private onDialogChanged(val: boolean) {
    if (val) {
      this.localAnimal = JSON.parse(JSON.stringify(this.animal));
    }
  }

  private update() {
    if (this.$refs.form.validate()) {
      this.loading = true;
      this.updateAnimal(this.localAnimal)
        .then((success: any) => {
          if (success) {
            return this.readAnimals();
          }
          this.loading = false;
        })
        .then(() => {
          this.loading = false;
          this.dialog = false;
          this.localAnimal = null;
          this.$refs.form.resetValidation();
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
}
